import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, signal, computed, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-documents-tabbed-viewer',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './documents-tabbed-viewer.component.html',
  styleUrls: ['./documents-tabbed-viewer.component.scss'],
})
export class DocumentsTabbedViewerComponent implements OnInit, OnChanges {
  @Input() documents: any[] = [];
  @Input() initialDocumentId: string = '';
  @Input() entityId: string = '';
  @Input() selectedDocumentId: string = '';
  @Input() hideTabs: boolean = false;

  @Output() onDocumentChange = new EventEmitter<any>();

  activeDocumentId = signal<string>('');
  fileUrl = signal<string>('');
  isLoading = signal(true);
  error = signal<string | null>(null);
  isLoadingFile = signal(false);

  activeDocument = computed(() => {
    const docId = this.activeDocumentId();
    return this.documents.find((doc) => String(doc.file_id ?? doc.document_id) === docId) || null;
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documents'] && this.documents.length > 0 && !this.activeDocumentId()) {
      const initialId = this.selectedDocumentId || this.initialDocumentId || String(this.documents[0].file_id ?? this.documents[0].document_id);
      this.activeDocumentId.set(initialId);
      this.loadDocumentFile(initialId);
      return;
    }

    if (changes['selectedDocumentId'] && this.selectedDocumentId) {
      const id = String(this.selectedDocumentId);
      if (id !== this.activeDocumentId()) {
        this.activeDocumentId.set(id);
        this.loadDocumentFile(id);
      }
    }
  }

  ngOnInit(): void {
    if (this.documents.length > 0) {
      const initialId = this.selectedDocumentId || this.initialDocumentId || String(this.documents[0].file_id ?? this.documents[0].document_id);
      this.activeDocumentId.set(initialId);
      this.loadDocumentFile(initialId);
    } else {
      this.isLoading.set(false);
      this.error.set('Aucun document disponible');
    }
  }

  selectDocument(documentId: string): void {
    this.activeDocumentId.set(documentId);
    this.loadDocumentFile(documentId);
  }

  private loadDocumentFile(documentId: string): void {
    this.isLoadingFile.set(true);
    this.error.set(null);

    const doc = this.documents.find((d) => String(d.file_id ?? d.document_id) === documentId);
    const url = doc?.serve_url || doc?.file_link;
    if (!doc || !url) {
      this.error.set('Impossible de charger le document');
      this.isLoadingFile.set(false);
      return;
    }

    this.fileUrl.set(url);
    this.isLoading.set(false);
    this.isLoadingFile.set(false);
  }

  downloadDocument(): void {
    const doc = this.activeDocument();
    const url = doc?.serve_url || doc?.file_link;
    if (!doc || !url) return;

    const link = document.createElement('a');
    link.href = url;
    link.download = doc.file_name || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  closeViewer(): void {
    // This will be handled by parent component
  }
}
